module.exports = __webpack_public_path__ + "img/Admission.6c7e0874.png";